import HakAksesAplikasi from './HakAksesAplikasi';

export default HakAksesAplikasi;
